/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Typography, Tabs } from 'antd';
import type { TabsProps } from 'antd';

type HomePageUsModalProps = {
  contentHtml: string;
};

export const HomePageUsModal = ({ contentHtml }: HomePageUsModalProps) => {
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Desktop',
      children: (
        <div css={boxDesktopStyle}>
          <div css={contentDesktopStyle} dangerouslySetInnerHTML={{ __html: contentHtml }}></div>
        </div>
      )
    },
    {
      key: '2',
      label: 'Mobile',
      children: (
        <div css={boxMobileStyle}>
          <div
            css={contentMobileStyle}
            dangerouslySetInnerHTML={{ __html: contentHtml }}
          ></div>
        </div>
      )
    }
  ];
  return (
    <div>
      <div css={mainTitleStyles}>
        <Typography.Title css={titleStyles} level={5}>
          Xem trước
        </Typography.Title>
      </div>
      <div>
        <Tabs defaultActiveKey='1' items={items} />
      </div>
    </div>
  );
};

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const mainTitleStyles = css`
  padding-bottom: 1.3rem;
  border-bottom: 1px solid #f0f0f0;
`;

const boxDesktopStyle = css`
  border: 1px solid #dddddd;
  border-radius: 1.5rem;
  padding: 0 3rem;
  max-height: 50rem;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  align-items: flex-start;
  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  };
`;

const boxMobileStyle = css`
  border: 1px solid #dddddd;
  background-color: #e8e8e8;
  border-radius: 1.5rem;
  padding: 0 15rem;
  max-height: 50rem;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  align-items: flex-start;
  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  };
`;

const contentMobileStyle = css`
  background-color: #ffffff;
  padding: 1.6rem;
  width: 37.5rem;
  height: 100%
  overflow: auto;
  img {
    max-width: 100%;
    height: auto;
    object-fit: contain; 
  }
`;

const contentDesktopStyle = css`
  background-color: #ffffff;
  padding: 1.6rem;
  overflow: auto;
  img {
    max-width: 100%;
    height: auto;
    object-fit: contain; 
  }
`;
